<button [type]="type" [disabled]="buttonDisabled" (click)="onButtonClick()" [ngClass]="inputClass"
  class="w-full flex justify-center items-center gap-2 bg-primary text-white text-center hover:bg-[#163171] py-2 px-4 rounded-[4px] font-semibold transition duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
  <ng-content></ng-content>
  @if (loading) {
  <ng-container>
    <span class="spinner"></span>
  </ng-container>
  }
</button>